import {useMemo, useState} from "react";

export const useOtp = () => {
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpCode, setOtpCode] = useState("");

  const normalizedOtp = useMemo(
    () => (otpCode ?? "").replace(/\s/g, ""),
    [otpCode]
  );

  const isOtpValid = useMemo(() => {
    return !isOtpSent || /^\d{6}$/.test(normalizedOtp);
  }, [isOtpSent, normalizedOtp]);

  return {
    isOtpSent,
    otpCode,
    setOtpCode,
    onOtpSent: () => setIsOtpSent(true),
    isOtpValid,
    normalizedOtp,
  };
};
